export const QaQuestionFrag = `
fragment QaQuestionFrag on QAContainerQuestion { 
  question {
    value
  }
  answers {
    targetItems {
      id
      name
      displayName
      ... on QAContainerAnswer {
        text {
          value
        }
        nextQuestion {
          id: targetId
        }
        service {
          id: targetId
        }
      }
    }
  }
}`;
